/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

export function JournalVoucher10Info({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const { rows = [], debitAccountLabels = [], creditAccountLabels = [], totals = {} } = values;

  const handleChangeField = (path, val) => setFieldValue(path, val);

  const calculateRowSums = (row) => {
    const totalDebit = (row.debitValues || []).reduce((acc, v) => acc + (parseFloat(v) || 0), 0);
    const totalCredit = (row.creditValues || []).reduce((acc, v) => acc + (parseFloat(v) || 0), 0);
    
    const openingDebit = parseFloat(row.openingDebit) || 0;
    const openingCredit = parseFloat(row.openingCredit) || 0;
    
    const balance = (openingDebit + totalDebit) - (openingCredit + totalCredit);
    const closingDebit = balance > 0 ? balance : 0;
    const closingCredit = balance < 0 ? Math.abs(balance) : 0;

    return { ...row, totalDebit, totalCredit, closingDebit, closingCredit };
  };

  const updateCalculations = () => {
    const newRows = rows.map(calculateRowSums);
    
    const newTotals = {
      openingDebit: 0, openingCredit: 0,
      debitValues: [0, 0, 0, 0], totalDebit: 0,
      creditValues: [0, 0, 0, 0], totalCredit: 0,
      closingDebit: 0, closingCredit: 0
    };

    newRows.forEach(r => {
      newTotals.openingDebit += parseFloat(r.openingDebit) || 0;
      newTotals.openingCredit += parseFloat(r.openingCredit) || 0;
      (r.debitValues || []).forEach((v, i) => { newTotals.debitValues[i] += (parseFloat(v) || 0); });
      newTotals.totalDebit += r.totalDebit || 0;
      (r.creditValues || []).forEach((v, i) => { newTotals.creditValues[i] += (parseFloat(v) || 0); });
      newTotals.totalCredit += r.totalCredit || 0;
      newTotals.closingDebit += r.closingDebit || 0;
      newTotals.closingCredit += r.closingCredit || 0;
    });

    if (JSON.stringify(newRows) !== JSON.stringify(rows)) setFieldValue("rows", newRows);
    if (JSON.stringify(newTotals) !== JSON.stringify(totals)) setFieldValue("totals", newTotals);
  };

  useEffect(() => {
    updateCalculations();
  }, [JSON.stringify(rows.map(r => ({
    od: r.openingDebit, oc: r.openingCredit,
    dv: r.debitValues, cv: r.creditValues
  })))]);

  const addRow = () => setFieldValue("rows", [...rows, {
    index: rows.length + 1,
    description: "",
    openingDebit: 0, openingCredit: 0,
    debitValues: [0, 0, 0, 0], totalDebit: 0,
    creditValues: [0, 0, 0, 0], totalCredit: 0,
    closingDebit: 0, closingCredit: 0,
  }]);

  const removeRow = (idx) => {
    if (rows.length <= 1) return;
    setFieldValue("rows", rows.filter((_, i) => i !== idx));
  };

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "14px", lineHeight: "1.4" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "14px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "14px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    th: { border: "1px solid #000", padding: "4px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#f9f9f9" },
    td: { border: "1px solid #000", padding: 0, height: "30px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 4px", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 4px", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "14px" },
    rowLabel: { display: "flex", alignItems: "baseline", gap: "5px", marginBottom: "5px" },
  };

  return (
    <SoftBox style={s.container}>
      {/* HEADER */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
        <div style={{ width: "40%" }}>
          <div style={s.rowLabel}>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.unit} onChange={(e) => handleChangeField("unit", e.target.value)} /></div>
          <div style={s.rowLabel}>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.address} onChange={(e) => handleChangeField("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "60%" }}>
          <div style={{ fontWeight: "bold", fontSize: "15px" }}>Mẫu số S04a10-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      {/* TITLE */}
      <div style={{ textAlign: "center", margin: "10px 0" }}>
        <h2 style={{ margin: 0, textTransform: "uppercase", fontSize: "18px" }}>NHẬT KÝ CHỨNG TỪ SỐ 10</h2>
        <div style={{ fontSize: "14px", fontStyle: "italic", marginTop: "5px" }}>
            Ghi Có Tài khoản 121, 128, 136, 138, 141, 171, 221, 222, 228, 229, 243, 244, 333, 336, 337, 338, 344, 347, 353, 411, 412, 413, 414, 418, 419, 421
        </div>
        <div style={{ marginTop: 10, fontWeight: "bold" }}>
          Tháng <input disabled={containView} style={{ ...s.inputDotted, width: "50px", textAlign: "center" }} value={values.month} onChange={(e) => handleChangeField("month", e.target.value)} />
          {" "}năm <input disabled={containView} style={{ ...s.inputDotted, width: "70px", textAlign: "center" }} value={values.year} onChange={(e) => handleChangeField("year", e.target.value)} />
        </div>
      </div>

      {/* MATRIX TABLE */}
      <div style={{ overflowX: "auto", border: "1px solid #000" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "1500px", fontSize: "12px" }}>
          <thead>
            <tr>
              <th style={{ ...s.th, width: "40px" }} rowSpan={2}>Số TT</th>
              <th style={{ ...s.th, width: "200px" }} rowSpan={2}>Diễn giải</th>
              <th style={s.th} colSpan={2}>Số dư đầu tháng</th>
              <th style={s.th} colSpan={5}>Ghi Nợ Tài khoản..., ghi Có các tài khoản</th>
              <th style={s.th} colSpan={5}>Ghi Có Tài khoản..., ghi Nợ các tài khoản</th>
              <th style={s.th} colSpan={2}>Số dư cuối tháng</th>
              {!containView && <th style={{ ...s.th, width: "40px" }} rowSpan={3}>#</th>}
            </tr>
            <tr>
              <th style={{ ...s.th, width: "80px" }}>Nợ</th>
              <th style={{ ...s.th, width: "80px" }}>Có</th>
              {/* DEBIT COLS */}
              {[...Array(4)].map((_, i) => (
                <th key={i} style={{ ...s.th, width: "80px" }}>
                    <input disabled={containView} style={s.inputTableCenter} placeholder="..." value={debitAccountLabels[i]} onChange={(e) => {
                        const newLabels = [...debitAccountLabels];
                        newLabels[i] = e.target.value;
                        setFieldValue("debitAccountLabels", newLabels);
                    }} />
                </th>
              ))}
              <th style={{ ...s.th, width: "90px" }}>Cộng Nợ TK</th>
              {/* CREDIT COLS */}
              {[...Array(4)].map((_, i) => (
                <th key={i} style={{ ...s.th, width: "80px" }}>
                    <input disabled={containView} style={s.inputTableCenter} placeholder="..." value={creditAccountLabels[i]} onChange={(e) => {
                        const newLabels = [...creditAccountLabels];
                        newLabels[i] = e.target.value;
                        setFieldValue("creditAccountLabels", newLabels);
                    }} />
                </th>
              ))}
              <th style={{ ...s.th, width: "90px" }}>Cộng Có TK</th>
              <th style={{ ...s.th, width: "80px" }}>Nợ</th>
              <th style={{ ...s.th, width: "80px" }}>Có</th>
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>1</th>
              <th style={s.th}>2</th>
              <th style={s.th}>3</th>
              <th style={s.th}>4</th>
              <th style={s.th}>5</th>
              <th style={s.th}>6</th>
              <th style={s.th}>7</th>
              <th style={s.th}>8</th>
              <th style={s.th}>9</th>
              <th style={s.th}>10</th>
              <th style={s.th}>11</th>
              <th style={s.th}>12</th>
              <th style={s.th}>13</th>
              <th style={s.th}>14</th>
              <th style={s.th}>15</th>
              <th style={s.th}>16</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={idx}>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={row.index} onChange={(e) => {
                    const newRows = [...rows];
                    newRows[idx].index = e.target.value;
                    setFieldValue("rows", newRows);
                }} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={row.description} onChange={(e) => {
                    const newRows = [...rows];
                    newRows[idx].description = e.target.value;
                    setFieldValue("rows", newRows);
                }} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.openingDebit} onChange={(e) => {
                    const newRows = [...rows];
                    newRows[idx].openingDebit = e.target.value;
                    setFieldValue("rows", newRows);
                }} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.openingCredit} onChange={(e) => {
                    const newRows = [...rows];
                    newRows[idx].openingCredit = e.target.value;
                    setFieldValue("rows", newRows);
                }} /></td>
                {/* DEBIT VALUES */}
                {[...Array(4)].map((_, i) => (
                  <td key={i} style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.debitValues[i]} onChange={(e) => {
                      const newRows = [...rows];
                      newRows[idx].debitValues[i] = e.target.value;
                      setFieldValue("rows", newRows);
                  }} /></td>
                ))}
                <td style={{ ...s.td, textAlign: "right", paddingRight: "4px", backgroundColor: "#eee" }}>{fmt(row.totalDebit)}</td>
                {/* CREDIT VALUES */}
                {[...Array(4)].map((_, i) => (
                  <td key={i} style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.creditValues[i]} onChange={(e) => {
                      const newRows = [...rows];
                      newRows[idx].creditValues[i] = e.target.value;
                      setFieldValue("rows", newRows);
                  }} /></td>
                ))}
                <td style={{ ...s.td, textAlign: "right", paddingRight: "4px", backgroundColor: "#eee" }}>{fmt(row.totalCredit)}</td>
                <td style={{ ...s.td, textAlign: "right", paddingRight: "4px", backgroundColor: "#eee" }}>{fmt(row.closingDebit)}</td>
                <td style={{ ...s.td, textAlign: "right", paddingRight: "4px", backgroundColor: "#eee" }}>{fmt(row.closingCredit)}</td>
                {!containView && <td style={{ ...s.td, textAlign: "center" }}><button type="button" style={s.removeBtn} onClick={() => removeRow(idx)}>-</button></td>}
              </tr>
            ))}
            
            {/* TOTALS ROW */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#fafafa" }}>
              <td style={s.td} colSpan={2} align="center">Cộng</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(totals.openingDebit)}</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(totals.openingCredit)}</td>
              {totals.debitValues?.map((v, i) => (
                <td key={i} style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(v)}</td>
              ))}
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(totals.totalDebit)}</td>
              {totals.creditValues?.map((v, i) => (
                <td key={i} style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(v)}</td>
              ))}
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(totals.totalCredit)}</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(totals.closingDebit)}</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(totals.closingCredit)}</td>
              {!containView && <td style={s.td}></td>}
            </tr>
          </tbody>
        </table>
      </div>

      {!containView && (
        <SoftBox textAlign="center" mt={2}>
          <SoftButton variant="outlined" color="dark" size="small" onClick={addRow}>+ Thêm dòng</SoftButton>
        </SoftBox>
      )}

      {/* FOOTER INFO */}
      <div style={{ marginTop: "15px" }}>
          Đã ghi Sổ Cái ngày <input disabled={containView} style={{ ...s.inputDotted, width: "30px", textAlign: "center" }} value={values.recordedToLedgerDay} onChange={(e) => handleChangeField("recordedToLedgerDay", e.target.value)} />
          {" "} tháng <input disabled={containView} style={{ ...s.inputDotted, width: "30px", textAlign: "center" }} value={values.recordedToLedgerMonth} onChange={(e) => handleChangeField("recordedToLedgerMonth", e.target.value)} />
          {" "} năm <input disabled={containView} style={{ ...s.inputDotted, width: "60px", textAlign: "center" }} value={values.recordedToLedgerYear} onChange={(e) => handleChangeField("recordedToLedgerYear", e.target.value)} />
      </div>

      {/* SIGNATURES */}
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "25px", textAlign: "center" }}>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Người ghi sổ</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Ký, họ tên)</div>
          <SoftBox mt={6}><input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.ledgerClerk} onChange={(e) => handleChangeField("ledgerClerk", e.target.value)} /></SoftBox>
        </div>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Kế toán trưởng</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Ký, họ tên)</div>
          <SoftBox mt={6}><input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.chiefAccountant} onChange={(e) => handleChangeField("chiefAccountant", e.target.value)} /></SoftBox>
        </div>
        <div style={{ width: "40%" }}>
          <div style={{ fontStyle: "italic", fontSize: "13px", marginBottom: "3px" }}>
            Ngày <input disabled={containView} style={s.inputDottedSmall} value={values.signingDay} onChange={(e) => handleChangeField("signingDay", e.target.value)} /> tháng <input disabled={containView} style={s.inputDottedSmall} value={values.signingMonth} onChange={(e) => handleChangeField("signingMonth", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "50px" }} value={values.signingYear} onChange={(e) => handleChangeField("signingYear", e.target.value)} />
          </div>
          <div style={{ fontWeight: "bold" }}>Người đại diện theo pháp luật</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Ký, họ tên, đóng dấu)</div>
          <SoftBox mt={6}><input disabled={containView} style={{ ...s.inputDotted, width: "200px", textAlign: "center" }} value={values.legalRepresentative} onChange={(e) => handleChangeField("legalRepresentative", e.target.value)} /></SoftBox>
        </div>
      </div>
    </SoftBox>
  );
}
